import * as React from 'react'
import type { LinkProps } from 'types/content-editor'
import Input from 'components/ui/input'
import Label from 'components/ui/label'
type Props = {
  value: LinkProps
  className?: string
  onChange: (e: React.SyntheticEvent<any>) => any
  validationErrors:
    | {
        link?: string
      }
    | null
    | undefined
}

const LinkPropsView = ({
  className,
  value,
  onChange,
  validationErrors,
}: Props): React.ReactElement<'div'> => {
  const { caption, url } = value
  return (
    <div className={className}>
      <div className="rich-text-toolbar__settings__list__row">
        <div className="rich-text-toolbar__settings__prop">Text to display</div>
        <div className="rich-text-toolbar__settings__value">
          <Input
            value={caption || url}
            name="caption"
            onChange={onChange}
            className="Campaigns_LargeInput"
          />
        </div>
      </div>
      <div className="rich-text-toolbar__settings__list__row">
        <div className="rich-text-toolbar__settings__prop">
          <Label
            validationError={validationErrors && validationErrors.link}
            caption="LINK"
          />
        </div>
        <div className="rich-text-toolbar__settings__value">
          <Input
            value={url}
            name="url"
            onChange={onChange}
            className="Campaigns_LargeInput"
          />
        </div>
      </div>
    </div>
  )
}

export default LinkPropsView
